// Which screen the mobile Watchlist is showing: the list picker, or one list
// opened.
//
// The mobile Watchlist does not change route when you open a list — it is
// internal state inside WatchlistMobile ("picker" | "detail" | "add"), and the
// URL stays on /search or /<slug>/watchlist throughout. So it pushes a history
// entry on open and relies on the APP HEADER's back arrow (navigate(-1)) to pop
// it; the popstate handler then returns to the picker.
//
// On the main site that works, because "/search" is one of the paths the header
// draws a back arrow for. Inside a league the route is /<slug>/watchlist, which
// is not, so the header drew the avatar instead and there was nothing on screen
// to go back with. Client: "Today I was testing the watchlist on mobile, and
// when I got into a specific watchlist, I was stuck; I couldn't get out."
//
// The header cannot read component state, and history.state does not re-render
// React, so the screen is published here instead. Same shape as
// utils/sidebarCollapse — a value plus a window event — because that is the
// idiom this codebase already uses for exactly this problem.
//
// Deliberately module state, not sessionStorage: this is where the user is right
// now, not a preference. A reload lands on the picker, which is true.

const EVENT_NAME = "qushiWatchlistMobileScreen";

let current = "picker";

export const getWatchlistMobileScreen = () => current;

export const setWatchlistMobileScreen = (screen) => {
  const next = screen || "picker";
  if (current === next) return;
  current = next;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

// "Is a single list open?" — the one question the header asks.
//
// "add" is NOT included: MobileAddAssets carries its own close control, so it is
// not a screen anyone can be stuck on, and the client's spec names only the
// opened watchlist.
export const isWatchlistDetailOpen = () => current === "detail";

export const subscribeWatchlistMobileScreen = (cb) => {
  const handler = () => cb();
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};
